import { createSelector } from "@reduxjs/toolkit";

import type { IContactsReducerState } from "./reducer";

const getContactsState = (state: { contacts: IContactsReducerState }): IContactsReducerState => state.contacts;

export const getContactData = createSelector(getContactsState, (state) => state.contacts);

export const getContactsIsFetching = createSelector(getContactsState, (state) => state.isFetching);

export const getContactsHasError = createSelector(getContactsState, (state) => state.hasError);

export const getContactsExists = (state: { contacts: IContactsReducerState }): boolean => getContactsIsFetching(state) || getContactData(state) !== null;
